"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var DescriptionIcon_1 = require("../../defaults/DescriptionIcon");
var react_1 = __importDefault(require("react"));
var _1 = require("./");
var styled_components_1 = __importDefault(require("styled-components"));
var _styled_1 = require("../../styled-components");
var DescriptionIconContainer = styled_components_1.default(_styled_1.DefaultStyled)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  align-items: ", ";\n  justify-content: ", ";\n"], ["\n  display: flex;\n  align-items: ",
    ";\n  justify-content: ",
    ";\n"])), function (_a) {
    var _b;
    var descriptionConfig = _a.descriptionConfig;
    return ((_b = descriptionConfig === null || descriptionConfig === void 0 ? void 0 : descriptionConfig.defaultCss) === null || _b === void 0 ? void 0 : _b.alignItems) || '';
}, function (_a) {
    var _b, _c, _d;
    var descriptionConfig = _a.descriptionConfig;
    if (((_b = descriptionConfig === null || descriptionConfig === void 0 ? void 0 : descriptionConfig.defaultCss) === null || _b === void 0 ? void 0 : _b.textAlign) === 'left') {
        return 'flex-start';
    }
    else if (((_c = descriptionConfig === null || descriptionConfig === void 0 ? void 0 : descriptionConfig.defaultCss) === null || _c === void 0 ? void 0 : _c.textAlign) === 'center') {
        return 'center';
    }
    else if (((_d = descriptionConfig === null || descriptionConfig === void 0 ? void 0 : descriptionConfig.defaultCss) === null || _d === void 0 ? void 0 : _d.textAlign) === 'right') {
        return 'flex-end';
    }
    return 'flex-start';
});
var DescriptionIcon = function (_a) {
    var descriptionConfig = _a.descriptionConfig, iconConfig = _a.iconConfig, defaultCss = _a.defaultCss, restConfig = __rest(_a, ["descriptionConfig", "iconConfig", "defaultCss"]);
    return (react_1.default.createElement(DescriptionIconContainer, __assign({ defaultCss: defaultCss }, restConfig),
        ((iconConfig === null || iconConfig === void 0 ? void 0 : iconConfig.icon) || (iconConfig === null || iconConfig === void 0 ? void 0 : iconConfig.url)) && (react_1.default.createElement(_1.Icon, __assign({}, DescriptionIcon_1.defaultIconConfig, iconConfig))),
        react_1.default.createElement(_1.Text, __assign({}, descriptionConfig))));
};
exports.default = DescriptionIcon;
var templateObject_1;
//# sourceMappingURL=DescriptionIcon.js.map